import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { languageNames } from '../translations';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languages = Object.keys(languageNames);

  // Сопоставление языковых кодов с кодами стран для флагов
  const countryCodeMap = {
    en: 'us', // Английский -> флаг США
    de: 'de', // Немецкий -> флаг Германии
    fr: 'fr', // Французский -> флаг Франции
    it: 'it', // Итальянский -> флаг Италии
    es: 'es'  // Испанский -> флаг Испании
  };

  const getCountryCode = (lang) => countryCodeMap[lang] || 'un';

  return (
    <div className="language-switcher">
      <button 
        className="language-current"
        onClick={() => setIsOpen(!isOpen)}
      >
        {/* Используем span с классами из flag-icons */}
        <span className={`fi fi-${getCountryCode(language)} fis`}></span>
        <span>{languageNames[language]}</span>
        <span className="arrow">▼</span>
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {languages.map((lang) => (
            <button
              key={lang}
              className={`language-option ${language === lang ? 'active' : ''}`}
              onClick={() => {
                changeLanguage(lang);
                setIsOpen(false);
              }}
            >
              {/* Флаг для каждого языка в выпадающем меню */}
              <span className={`fi fi-${getCountryCode(lang)} fis`}></span>
              <span>{languageNames[lang]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;